export const BANK_PREFIXES = ["BOA", "Chase"];
export const EMI_PREFIXES = ["ER", "EMI"];
export const CAPITAL_PREFIX = "CC";

export const formatDate = (date: string) => {
  if (!date) return "";

  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return date;

  return parsedDate.toLocaleDateString("en-US");
};

export function inferShareholderTransactionType(item: any): string {
  const creditedAccountName = item?.creditedAccount?.name ?? "";

  if (BANK_PREFIXES.some((prefix) => creditedAccountName.startsWith(prefix))) {
    return "Distribution";
  }

  if (creditedAccountName) {
    return "Deposit";
  }

  return "";
}

export function inferTransactionType(item: any): string {
  const creditedName = item?.creditedAccount?.name ?? "";
  const debitedName = item?.debitedAccount?.name ?? "";

  if (
    EMI_PREFIXES.some(
      (prefix) =>
        creditedName.startsWith(prefix) || debitedName.startsWith(prefix)
    )
  ) {
    return "EMI";
  } else {
      return "Capital";
    }
}
